import React from 'react';
const testimonials = [{
  text: "J'anime cinq cours de gym douce par semaine dans deux associations et je passais mes dimanches à construire mes séances. Depuis que j'utilise les modèles de séances prêtes à utiliser, je choisis un cours de 45 minutes, j'ajuste deux exercices et c'est prêt. J'ai récupéré mes week-ends et mes participants trouvent les cours beaucoup plus variés.",
  author: 'Nathalie Berthier',
  role: 'Animatrice sportive spécialisée seniors, 47 ans',
  location: 'Lyon, France'
}, {
  text: "Dans mes groupes, j'ai des personnes de 65 ans très actives et d'autres avec une prothèse de hanche. La banque de variations d'exercices m'a changé la vie : j'ai les régressions et les progressions déjà prêtes, je n'improvise plus devant le groupe.",
  author: 'Julien Marchand',
  role: 'Coach sportif en salle, cours collectifs seniors, 38 ans',
  location: 'Bordeaux, France'
}, {
  text: "Je suis enseignante en activité physique adaptée et j'interviens en résidence autonomie. Les fiches d'évaluation et le suivi mensuel me permettent enfin de montrer des progrès concrets aux familles et à la direction. Le renouvellement des ateliers est beaucoup plus simple à défendre.",
  author: 'Camille Dupuis',
  role: 'Enseignante APA en résidence autonomie, 34 ans',
  location: 'Nantes, France'
}, {
  text: "J'avais des dossiers pleins de PDF, des notes de formation et des vidéos enregistrées, mais aucun ordre. Aujourd'hui tout est dans un seul système : programmes de 12 semaines déjà construits et planification annuelle. Je prépare un trimestre entier en une soirée.",
  author: 'Sophie Lemoine',
  role: 'Gérante de studio de cours pour seniors, 52 ans',
  location: 'Strasbourg, France'
}, {
  text: "Je débutais avec le public senior et j'avais peur de mal faire sur l'équilibre et la prévention des chutes. Les circuits fonctionnels du bonus m'ont donné des protocoles clairs et sûrs. Mes cours sont complets et les participants se déplacent avec plus de confiance.",
  author: 'Sébastien Girard',
  role: 'Éducateur sportif en collectivité, 31 ans',
  location: 'Rennes, France'
}];
export function Testimonials() {
  return <section className="py-6 px-4 sm:px-6 bg-white" data-id="element-139" data-mp="1ofzs0ixqdjzm">
      <h2 className="text-2xl sm:text-4xl font-display text-center text-navy leading-none mb-4" data-id="element-140" data-mp="1ji803ox35xvf">
        Ils utilisent déjà le système
      </h2>

      <div className="flex flex-col gap-2.5 max-w-3xl mx-auto" data-id="element-141" data-mp="1ejwslku9jzgd">
        {testimonials.map(t => <div key={t.author} className="bg-cream border border-gold/30 p-3.5 rounded-lg" data-id="element-142" data-mp="19rmvnkuqdz4l">
            <p className="text-gold text-xs tracking-tighter mb-1" aria-label="5 sur 5" data-id="element-143" data-mp="14r8xcuixm3jr">
              ⭐⭐⭐⭐⭐
            </p>
            <p className="text-ink text-[12.5px] sm:text-sm leading-snug italic mb-2.5" data-id="element-144" data-mp="vrc1o8y4k4f7">
              « {t.text} »
            </p>
            <div className="flex items-center gap-3 border-t border-gold/20 pt-2" data-id="element-145" data-mp="qvn94pkivnse">
              <div className="w-9 h-9 rounded-full bg-navy/10 border border-navy/20 flex items-center justify-center text-navy font-heading font-bold shrink-0" data-id="element-146" data-mp="32ge55awa7k0t">
                {t.author.charAt(0)}
              </div>
              <div className="leading-tight" data-id="element-147" data-mp="3cczajxc7qx56">
                <p className="font-heading font-bold text-navy text-[13px] sm:text-sm" data-id="element-148" data-mp="3ggym01imz5ro">
                  {t.author}
                </p>
                <p className="text-[11px] text-ink" data-id="element-149" data-mp="2js91s4jje12j">
                  {t.role} — {t.location}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}